import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';

const GET_MY_ACCOUNT_ACCREDITATIONS = graphql(`
  query GetMyAccountAccreditations {
    me {
      user {
        account {
          id
          accreditations {
            mcsCertificationNumber
            mcsBatteryStorageCertified
          }
        }
      }
    }
  }
`);

const useGetMyAccountAccreditations = () => {
  const { data, ...rest } = useQuery({
    queryKey: meKeys.accountAccreditations(),
    queryFn: () => gqlClient.request(GET_MY_ACCOUNT_ACCREDITATIONS),
  });

  return { accreditations: data?.me.user.account.accreditations, ...rest };
};

export default useGetMyAccountAccreditations;
